import { render, staticRenderFns } from "./domains.vue?vue&type=template&id=4f617edd&"
import script from "./domains.vue?vue&type=script&lang=js&"
export * from "./domains.vue?vue&type=script&lang=js&"
import style0 from "./domains.vue?vue&type=style&index=0&id=4f617edd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./domains.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports